import { useState, useEffect, useRef, useCallback } from "react";
import { FaBell } from "react-icons/fa";

const Notificaciones = ({ pendientes, notificaciones, loading, hasMore, onOpen, onLoadMore }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const bellRef = useRef(null);
  const dropdownRef = useRef(null);
  const scrollRef = useRef(null);

  const handleToggle = () => {
    if (!isOpen) {
      setUnreadCount(pendientes);
      onOpen?.();
    }
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        bellRef.current &&
        !bellRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el || !hasMore || loading) return;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 80) {
      onLoadMore?.();
    }
  }, [hasMore, loading, onLoadMore]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const formatFecha = (dateStr) => {
    if (!dateStr) return "";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("es-ES", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dateStr;
    }
  };

  return (
    <>
      <div className="notificacion" onClick={handleToggle} ref={bellRef}>
        <FaBell className="notificacionIcon" />
        {pendientes > 0 && (
          <span className="notificacionBadge">{pendientes}</span>
        )}
      </div>
      {isOpen && (
        <div className="dropdown show" ref={dropdownRef}>
          <div className="notificacionesHeader">Notificaciones</div>
          {loading && notificaciones.length === 0 ? (
            <div className="notificacionesLoading">Cargando...</div>
          ) : notificaciones.length === 0 ? (
            <div className="notificacionesEmpty">No hay notificaciones</div>
          ) : (
            <div className="notificacionesList" ref={scrollRef}>
              {notificaciones.map((notif, idx) => (
                <div
                  key={idx}
                  className={`notificacionItem${idx < unreadCount ? " notificacionItem--new" : ""}`}
                >
                  {idx < unreadCount && <span className="notificacionItemDot" />}
                  <div className="notificacionAsunto">{notif.asunto}</div>
                  <div className="notificacionMensaje">{notif.mensaje}</div>
                  <div className="notificacionFecha">{formatFecha(notif.fecha_envio)}</div>
                </div>
              ))}
              {loading && hasMore && (
                <div className="notificacionesLoadingMore">Cargando más...</div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Notificaciones;
